// 画面幅
windowWidth = $(window).width();


document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);
  //setTimeout
  setTimeout(function () {
    document.documentElement.classList.add("is-splash01");
  }, 2000);

  ScrollTrigger.matchMedia({
    // メディアのサイズに関係なく、すべてに適用する
    all: function () {
      ScrollTrigger.create({
        trigger: "#scrolltoexplore",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-open",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec01",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active01",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec02",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active02",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec03",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active03",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec04",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active04",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec05",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active05",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec06",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active06",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec07",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active07",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec08",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active08",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: "#sec09",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-active09",
        }, //クラスをつけたり、外したりできる
      });
      ScrollTrigger.create({
        trigger: ".footer",
        start: "top 80%",
        end: "top -99999%",

        toggleClass: {
          targets: ".pageNavi",
          className: "is-close",
        }, //クラスをつけたり、外したりできる
      });

      if(document.querySelector(".section01:not([data-no-animate])") && document.querySelector(".section02")){
        gsap.to(".fvImg", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: ".section01",
            start: "bottom 100%",
            end: "bottom +=200",
            scrub: "true",
          },
          scale: "1",
        });
        
        gsap.to(".scrollAttention", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: ".section01",
            start: "bottom 70%",
            end: "bottom 50%",
            scrub: "true",
          },
          autoAlpha: "0",
        });
        gsap.to(".section01", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: ".section02",
            start: "top 50%",
            end: "top 0%",
            scrub: "true",
          },
          filter: "brightness(0.6)",
          y: "10vw",
        });
      }

      if(document.querySelector(".sec02Item") && document.querySelector(".sec02sticky")){
        gsap.to(".sec02Item", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: ".sec02sticky",
            start: "top 50%",
            end: "top 0%",
            scrub: "true",
          },
          filter: "brightness(0.6)",
          y: "10vw",
        });
      }
      if(document.querySelector(".mostCare")){
        ScrollTrigger.create({
          trigger: ".textHeight",
          start: "top 95%",
          end: "top -99999%",
          toggleClass: {
            targets: ".mostCare",
            className: "is-active01",
          }, //クラスをつけたり、外したりできる
        });
        ScrollTrigger.create({
          trigger: ".textHeight",
          start: "top 95%",
          end: "top -99999%",
          toggleClass: {
            targets: ".mostCare",
            className: "is-active01",
          }, //クラスをつけたり、外したりできる
        });
        ScrollTrigger.create({
          trigger: ".textHeight",
          start: "top 95%",
          end: "top -99999%",
          toggleClass: {
            targets: ".mostCare",
            className: "is-active01",
          }, //クラスをつけたり、外したりできる
        });
          ScrollTrigger.create({
            trigger: ".textHeight",
            start: "top 95%",
            end: "top -99999%",
            toggleClass: {
              targets: ".mostCare",
              className: "is-active01",
            }, //クラスをつけたり、外したりできる
          });
        ScrollTrigger.create({
          trigger: ".textHeight",
          start: "top 95%",
          end: "top -99999%",
          toggleClass: {
            targets: ".mostCare",
            className: "is-active01",
          }, //クラスをつけたり、外したりできる
        });
        ScrollTrigger.create({
          trigger: ".textHeight",
          start: "top -50%",
          end: "top -99999%",
          toggleClass: {
            targets: ".mostCare",
            className: "is-active02",
          }, //クラスをつけたり、外したりできる
        });
      }

      if(document.querySelector(".section02") && document.querySelector(".section03")){
        gsap.to(".section02", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: ".section03",
            start: "top 50%",
            end: "top 0%",
            scrub: "true",
          },
          filter: "brightness(0.6)",
          y: "10vw",
        });
      }
      if(document.querySelector(".section03") && document.querySelector(".section04")){
        gsap.to(".section03", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: ".section04",
            start: "top 50%",
            end: "top 0%",
            scrub: "true",
          },
          filter: "brightness(0.6)",
          y: "10vw",
        });
      }
      if(document.querySelector(".section04") && document.querySelector(".section05")){
        gsap.to(".section04", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: ".section05",
            start: "top 50%",
            end: "top 0%",
            scrub: "true",
          },
          filter: "brightness(0.6)",
          y: "10vw",
        });
      }

      gsap.to(".sectionBg img", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section03",
          start: "bottom 100%",
          end: "bottom -100%",
          scrub: "true",
        },
        y: "-20vw",
      });

      gsap.to(".sectionBg", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section07",
          start: "top 50%",
          end: "top 0%",
          scrub: "true",
        },
        opacity: "0",
        visibility: "hidden",
        transform: "translateY(-5vw)",
      });
      gsap.to(".sectioncv", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section06",
          start: "top 80%",
          end: "top 70%",
          scrub: "true",
        },
        opacity: "1",
        visibility: "visible",
        transform: "translateY(0)",
      });
      gsap.to(".sectioncv", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section07",
          start: "top 85%",
          end: "top -10%",
          scrub: "true",
        },
        opacity: "0",
      });
      gsap.to(".sectionBg", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section07",
          start: "top 50%",
          end: "top 0%",
          scrub: "true",
        },
        opacity: "0",
      });
      gsap.to(".lineupBg", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section07",
          start: "top 0%",
          end: "top -10%",
          scrub: "true",
        },
        opacity: "1",
      });
      gsap.to(".section05", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section06",
          start: "top 50%",
          end: "top 0%",
          scrub: "true",
        },
        filter: "brightness(0.6)",
        y: "10vw",
      });

      gsap.to(".section06", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section07",
          start: "top 50%",
          end: "top 0%",
          scrub: "true",
        },
        filter: "brightness(0.6)",
        y: "10vw",
      });
      gsap.to(".section05Head01", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section05Head01",
          start: "top 100%",
          end: "top 0%",
          scrub: "true",
        },
        transform: "translateX(-0vw)",
      });
      gsap.to(".section05Head02", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section05Head01",
          start: "top 100%",
          end: "top 0%",
          scrub: "true",
        },
        transform: "translateX(0vw)",
      });

      gsap.to(".voiceHead", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".voiceBox",
          start: "bottom 70%",
          end: "bottom 60%",
          scrub: "true",
        },
        opacity: "0",
      });
      gsap.to(".lineupBg img", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section07",
          start: "bottom 150%",
          end: "bottom -100%",
          scrub: "true",
        },
        y: "-20vw",
      });
      gsap.to(".lineupBg img", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section08",
          start: "top 0%",
          end: "top -1%",
          scrub: "true",
        },
        opacity: "0",
      });
      gsap.to(".footer", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section08",
          start: "top 30%",
          end: "top 20%",
          scrub: "true",
        },
        opacity: "1",
      });

      gsap.to(".sec05text", {
        scrollTrigger: {
          toggleActions: "play pause resume reverse",
          trigger: ".section05",
          start: "top 100%",
          end: "top 0%",
          scrub: "true",
        },
        transform: "translateX(0)",
      });
    },
    "(min-width: 768px)": function () {
      if(document.querySelector(".notification_wrap")){
        let triggerElement = document.querySelector(".slideshow") ? document.querySelector(".slideshow") : document.querySelector(".section01");
        if(document.querySelector(".fvCampaignBanner")) {
          triggerElement = document.querySelector(".fvCampaignBanner");
        }
        gsap.to(".notification_wrap", {
          scrollTrigger: {
            toggleActions: "play pause resume reverse",
            trigger: triggerElement,
            start: "bottom 70%",
            end: "bottom 50%",
            scrub: "true",
          },
          autoAlpha: "0",
          right: "-100px",
        });
      }
    },
    //end matchMedia
  });

  // const text = document.querySelector(".text");
  // setTimeout(() => {
  //   text.classList.add("is-active");
  // }, 3200);

  // const text2 = document.querySelector(".text2");
  // setTimeout(() => {
  //   text2.classList.add("is-active");
  // }, 3200);

  // const text3 = document.querySelector(".text3");
  // setTimeout(() => {
  //   text3.classList.add("is-active");
  // }, 3200);
});



// slick
$(function () {
  $('.slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    draggable: true,
    arrows: false,
    swipe: true,
    infinite: true,
    speed: 500,
    fade: false,
    lazyLoad: 'progressive',
  });
});

$(function () {
  $('.natural_slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    draggable: true,
    arrows: false,
    swipe: true,
    infinite: true,
    speed: 500,
    fade: false,
    lazyLoad: 'progressive',
  });
});
$(window).on("resize orientationchange", function () {
  $(".slider").slick("resize");
});


$(function () {
  $(".bestseller_slide")
    .on("init", function (event, slick) {
      $(this).append('<div class="slick-num"><span class="now-count"></span> / <span class="all-count"></span></div>');
      const zeroPadding = `0${slick.currentSlide + 1}`.slice(-2);
      const zeroTotal = `0${slick.slideCount}`.slice(-2);
      $(".now-count").text(zeroPadding); // 現在のスライド番号
      $(".all-count").text(zeroTotal); // スライドの総数
    })

    .slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      autoplay: false,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      draggable: true,
      arrows: true,
      swipe: true,
      infinite: false,
      speed: 100,
      fade: false,
      cssEase: 'linear',
      lazyLoad: 'progressive',
      prevArrow: '<div class="prev_arrow"></div>',
      nextArrow: '<div class="next_arrow"></div>',
    })

    .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      const zeroPadding = `0${nextSlide + 1}`.slice(-2);
      $(".now-count").text(zeroPadding); // 現在のスライド番号の次のスライドになったら番号を+1
    });
});



$(function () {
  if (windowWidth <= 767) {
    $('.voiceBox').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      centerMode: false,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      draggable: true,
      arrows: false,
      swipe: true,
      infinite: true,
      speed: 500,
      fade: false,
      lazyLoad: 'progressive',
    });
  } else{}

  $('.interview_slide').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: true,
    autoplay: false,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    pauseOnFocus: false,
    dots: false,
    draggable: true,
    arrows: true,
    swipe: true,
    infinite: false,
    speed: 500,
    fade: false,
    lazyLoad: 'progressive',
    prevArrow: '<div class="prev_arrow"></div>',
    nextArrow: '<div class="next_arrow"></div>',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          autoplay: true,
          infinite: true,
        },
      },
    ],
  });
});

// $(function () {
//   $('.js-notification').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: false,
//     autoplaySpeed: 3000,
//     pauseOnHover: false,
//     pauseOnFocus: false,
//     draggable: true,
//     arrows: true,
//     dots: true,
//     swipe: true,
//     infinite: false,
//     speed: 500,
//     fade: false,
//     lazyLoad: 'progressive',
//   });
// });

  const notification = new Swiper(
    ".js-notification",
    {
      slidesPerView: 1,
      loop: true,
      centeredSlides: true,
      speed: 500,
      spaceBetween: 30,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "progressbar"
      },
    }
  );

// swiper
$(function () {
  new Swiper(".js-careList", {
    slidesPerView: 1.5,
    spaceBetween: 8,
    watchSlidesProgress: !0,
    breakpoints: {
      768: {
        slidesPerView: 3.5,
        spaceBetween: 56
      }
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: !0
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  $('.js-acc-btn').click(function() {
    $(this).closest('.js-acc').find('.js-acc-item').toggleClass("is-open");
    $(this).toggleClass("is-open");
  });
});



$(window).on('load resize',function(){
  var winHeight = $(window).height();
  var h100Content1 = $('.section0502 .txt_box').innerHeight() + 50;
  var h100Content2 = $('.section0503 .txt_box').innerHeight() + 50;
  var h100Content3 = $('.section0504 .txt_box').innerHeight() + 50;
  var scaleContent1 = winHeight / h100Content1;
  var scaleContent2 = winHeight / h100Content2;
  var scaleContent3 = winHeight / h100Content3;

  if (windowWidth <= 767) {
  } else{
    if(scaleContent1 < 1){
      $('.section0502 .txt_box').css({'transform':'scale(' + scaleContent1 +')'});
    }else{
      $('.section0502 .txt_box').css({'transform':'scale(1)'});
    }

    if(scaleContent2 < 1){
      $('.section0503 .txt_box').css({'transform':'scale(' + scaleContent1 +')'});
    }else{
      $('.section0503 .txt_box').css({'transform':'scale(1)'});
    }

    // if(scaleContent3 < 1){
    //   $('.section0504 .txt_box').css({'transform':'scale(' + scaleContent1 +')'});
    // }else{
    //   $('.section0504 .txt_box').css({'transform':'scale(1)'});
    // }
  }
});



$(function () {
  $('.notification_close_btn').on('click', function(){
    $('.notification_wrap').addClass('close');
  });
});

$(function() {
  showTop = ($(window).width() > 768 ? 700 : 200);
  if($(window).scrollTop() > showTop) $(".pagetop").css("opacity","1"); else $(".pagetop").css("opacity","0");
  $(window).scroll(function(){
    if($(window).scrollTop() > showTop) $(".pagetop").css("opacity","1"); else $(".pagetop").css("opacity","0");
  });
});